<template>
    <transition :name="effect">
        <router-link :style="customStyle" v-if="type === 'link' && show" :to="to" :class="['fab-btn', size, color]">
            <svg-icon :icon="icon"/>
        </router-link>
        <button type="button" @click="$emit('click')" :style="customStyle" v-else-if="type === 'button' && show" :class="['fab-btn', size, color]">
            <svg-icon :icon="icon"/>
        </button>
    </transition>
</template>

<script>
    export default {
        name: "Fab",
        props: {
            type: {
                type: String,
                default: 'link',
                validator: t => /(link|button)/gi.test(t)
            },
            icon: {
                type: String,
                default: 'filter'
            },
            color: {
                type: String,
                default: 'red'
            },
            to: {
                type: String || Object
            },
            effect: {
                type: String,
                default: 'bounce',
                validator: v => /(bounce)/gi.test(v)
            },
            size: {
                type: String,
                default: 'normal',
                validator: v => /(normal|mini)/gi.test(v)
            },
            customStyle: {
                type: Object
            }
        },
        data() {
            return {
                show: false
            }
        },
        mounted() {
            this.show = true
        }
    }
</script>
